import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';

import DepotGestionAutocomplete from 'components/Shared/DepotGestionAutocomplete';

import DropZone from 'components/Shared/DropZone';
import { ReclamationActionDetailCodes, ReclamationActionDetailType } from 'constants.js';

import stringHelper from 'utils/stringHelper';

import { MotifResolutionCodes } from 'constants.js';
import { CausePrincipaleCodes } from 'constants.js';

const styles = {
    formControl: {
        margin: 0,
        marginTop: 10,
        width: '100%'
    },

    heightLabel: {
        height: '30px'
    },

    input: {
        marginTop: 10,
        marginRight: 10
    }
};

/* Liste des réponses possibles */
const actions = [
    "Facturation du client depuis le stock magasin",
];

// Cloture
const clotureData = {
    motifResolutionCode: MotifResolutionCodes.RegularisationFacturationClient,
    causePrincipaleCode: CausePrincipaleCodes.ErreurPreparation,
    causePrincipaleDetailId: 0,
    utilisateurFautifId: 0,
    commentaire: '',
    mailAutomatique: ''
};

class DeclarerInversionArticleDialogContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            articles: props.articles.filter(x => x.typeAnomalie !== null).map(x => { return { codeArticleCommande: x.codeArticleCommande, designationArticleCommande: x.designationArticleCommande, quantiteCommande: x.quantiteCommande, codeArticleAnomalie: x.codeArticleAnomalie ?? '', quantiteAnomalie: x.quantiteAnomalie, descriptifAnomalie : x.descriptifAnomalie ?? '' }; }),
            numeroPiece: '',
            actionEffectuee: 0,
            fichiersIds: [],
            codeDepot: props.codeDepot,

            commentaire: ""
        };
    }
    

    componentDidMount() {
        const actionData = this.getActionData(this.state);

        this.props.onChange(actionData, clotureData);
    }

    getActionData(newState) {
        const { action } = this.props;

        console.log(newState);

        if (!newState.codeDepot) {
            return null;
        }

        if (newState.actionEffectuee === null) {
            return null;
        }

        if (stringHelper.isNullOrWhitespace(newState.numeroPiece)) {
            return null;
        }


        const actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Depot,
                type: ReclamationActionDetailType.CodeDepot,
                libelle: "Dépôt",
                position: 0,
                valeurString: newState.codeDepot
            },
            {
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: 'Action déjà effectuée vis à vis du client',
                position: 1,
                valeurString: actions[newState.actionEffectuee],
                valeurInteger: newState.actionEffectuee
            }, {
                code: ReclamationActionDetailCodes.NumeroPiece,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Numéro de pièce',
                position: 2,
                valeurString: newState.numeroPiece
            }]
        };


        // Articles
        let articles = newState.articles.filter(article => article.codeArticleCommande && article.quantiteAnomalie);
        if (articles.length === 0) {
            return null;
        }
        for (let i = 0; i < articles.length; i++) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.CodeArticleQuantite,
                type: ReclamationActionDetailType.CodeArticleQuantite,
                libelle: 'Code article commandé',
                position: actionData.details.length,
                valeurInteger: articles[i].quantiteCommande,
                valeurString: articles[i].codeArticleCommande
            });
            actionData.details.push({
                code: ReclamationActionDetailCodes.CodeArticleQuantite,
                type: ReclamationActionDetailType.CodeArticleQuantite,
                libelle: 'Code article reçu à la place',
                position: actionData.details.length,
                valeurInteger: articles[i].quantiteAnomalie,
                valeurString: articles[i].codeArticleAnomalie
            });
            actionData.details.push({
                code: ReclamationActionDetailCodes.Descriptif,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Descriptif article reçu à la place',
                position: actionData.details.length,
                valeurString: articles[i].descriptifAnomalie
            });
        }


        if (newState.commentaire) {

            let detail = {
                code: ReclamationActionDetailCodes.Commentaire,
                type: ReclamationActionDetailType.Texte,
                libelle: "Commentaire",
                position: actionData.details.length,
                valeurString: newState.commentaire
            };

            actionData.details.push(detail);
        }

        if (newState.fichiersIds.length > 0) {
            actionData.fichiersIds = newState.fichiersIds;
        }

        return actionData;
    }


    handleChange = (event, index) => {

        let newState = {
            ...this.state,
        };

        if (event.target.name === 'codeArticleAnomalie') {
            newState.articles[index].codeArticleAnomalie = event.target.value;
        }
        else if (event.target.name === 'quantiteAnomalie') {
            newState.articles[index].quantiteAnomalie = event.target.value;
        }
        else if (event.target.name === 'descriptifAnomalie') {
            newState.articles[index].descriptifAnomalie = event.target.value;
        }
        else {
            newState[event.target.name] = event.target.value;
        }



        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData, clotureData);
    }







    render() {
        const { classes } = this.props;
        const { articles, actionEffectuee, numeroPiece, codeDepot, commentaire } = this.state;

        console.log("render articles", articles);

        return (
            <DialogContent>
                <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>
                <Typography variant="body2" gutterBottom>{`Générer un dossier après-vente lié affecté au groupe Qualité Entrepôt`}</Typography>
                <Typography variant="body2" gutterBottom>{`Clôturer ce dossier après-vente`}</Typography>


                <FormControl margin="normal" className={classes.formControl}>
                    <DepotGestionAutocomplete
                        value={codeDepot}
                        onChange={(e, codeDepot, depot) => { this.handleChange({ target: { name: 'codeDepot', value: codeDepot } }); }}
                        label={"Dépôt"}
                        magasinsSeulement={false}
                        plateformesSeulement={false}
                        autoFocus
                        modeTri={0}
                        required={true}
                        disabled={false}
                    />
                </FormControl>


                {articles && articles.map((article, index) => {
                    return (
                        <React.Fragment key={index}>
                            <div>
                                <TextField className={classes.input} disabled label="Code article" value={article.codeArticleCommande} />
                                <TextField className={classes.input} disabled label="Désignation" value={article.designationArticleCommande} />
                                <TextField className={classes.input} disabled label="Quantité commandée" value={article.quantiteCommande} />
                            </div>
                            <div>
                                <TextField name="codeArticleAnomalie" className={classes.input} label="Code article reçu à la place" value={article.codeArticleAnomalie} onChange={e => this.handleChange(e, index)} required />
                                <TextField name="quantiteAnomalie" className={classes.input} label="Quantité reçue" value={article.quantiteAnomalie} onChange={e => this.handleChange(e, index)} />
                                <TextField name="descriptifAnomalie" className={classes.input} label="Descriptif" value={article.descriptifAnomalie} onChange={e => this.handleChange(e, index)} />
                            </div>
                        </React.Fragment>

                    );
                })}



                <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend">Action déjà effectuée vis à vis du client:</FormLabel>
                    <RadioGroup
                        aria-label="Action effectuée"
                        name="actionEffectuee"
                        value={actionEffectuee}
                        onChange={e => this.handleChange(e)}
                    >
                        {actions.map((reponse, index) => (
                            <FormControlLabel key={index} value={index} control={<Radio />} label={reponse} />
                        ))}

                    </RadioGroup>
                </FormControl>



                <TextField className={classes.input} id="numeroPiece" name="numeroPiece" label="Numéro de pièce" value={numeroPiece} onChange={this.handleChange} fullWidth required/>

                <TextField className={classes.formControl}
                    name="commentaire"
                    label="Commentaire"
                    placeholder="Commentaire"
                    multiline
                    margin="normal"
                    value={commentaire}
                    onChange={e => this.handleChange(e)}
                />

                <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
            </DialogContent>
        );
    }
}

DeclarerInversionArticleDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    codeDepot: PropTypes.string
};

export default withStyles(styles)(DeclarerInversionArticleDialogContent);